import { useSelector } from 'react-redux';
import { VendorToCompanyID, VendorToCompanyFullName } from '../components/shared/Company';

export const useCurrentCompanyID = () => {
  const { currentVendor } = useSelector((state) => state.vendor);

  return VendorToCompanyID(currentVendor);
};

export const useCurrentCompanyFullName = () => {
  const { currentVendor } = useSelector((state) => state.vendor);

  return VendorToCompanyFullName(currentVendor);
};
